import React, { useEffect, useRef, useState } from "react";
import {
  ConfigData,
  DefaulSorting,
} from "./configData";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import DownloadIcon from "../../../assets/shuttle_bus_booking/ic_download.svg";
import FilterIcon from "../../../assets/header/filter.svg";
import RefreshIcon from "../../../assets/header/refresh.svg";
import { Reusable_table } from "../../../components/reusableItems/table";
import "./report.css";
import { useLocation, useNavigate } from "react-router";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { Filter } from "./filter";
import { fetchShuttleBusBookingReport } from "../../../store/shuttle_bus_booking/report";
import * as XLSX from 'xlsx';

export const ShuttleBusBookingReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const exportLink = useRef(null);
  const query = new URLSearchParams(searchQuery);
  const { loading, report_list } = useSelector((state) => state.shuttleBusReport);
  const [showFilter, setShowFilter] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [filterValue, setFilterValue] = useState({
    start_date: "",
    end_date: "",
  });
  const userPermissions = getUserPermission();
  const viewPermssion = checkPermission(
    userPermissions,
    "clinic.access_clinic"
  );
  const getData = async (callback) => {
    dispatch(fetchShuttleBusBookingReport(filterValue))
  };

  useEffect(() => {
    getData();
  }, []);



  const RefreshData = () => {
    getData();
  };

  const handleFilterAction = () => {
    setShowFilter(!showFilter);
  };


  const icons = [
    {
      icon: FilterIcon,
      title: "Filter",
      action: handleFilterAction,
    },
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
  ];



  const handleClear = async () => {
    setSearchLoading(true);
    const data = clinic_list.data.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

    setTempData(data);
    setSearchValue("");
    // Add a 1-second delay before setting loading to false
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setSearchLoading(false);
  };



  const FilterAction = () => {
    setShowFilter(false);

    getData();
  };

  const filterClearAction = async () => {
    setShowFilter(false);
    setFilterValue({
      ...filterValue,
      hsc: "",
      claimable: "",
    });
    setShouldFetch(true);
  };

  useEffect(() => {
    if (shouldFetch) {
      getData();
      setShouldFetch(false);
    }
  }, [filterValue, shouldFetch]);

  const columns = [
    { id: "date", name: "Date" },
    { id: "pickup", name: "Pick-Up Point" },
    { id: "destination", name: "Destination" },
    { id: "boarded", name: "Boarded" },
    { id: "cancelled", name: "Cancelled" },
    { id: "absence", name: "Absence" },
    { id: "total", name: "Total" },
  ];


  const buildAOA = (rows, columns) => {
    return [
      // Header row
      columns.map(col => col.name),

      // Data rows
      ...rows.map(row =>
        columns.map(col => row[col.id] ?? "")
      ),
    ];
  };


  const exportToXlsx = (data, fileName) => {
    const wb = XLSX.utils.book_new();

    const enAOA = buildAOA(data, columns);

    const sheetEN = XLSX.utils.aoa_to_sheet(enAOA);

    XLSX.utils.book_append_sheet(wb, sheetEN, "EN");

    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };


  const handleExportAction = () => {
    exportToXlsx(report_list, "Report");
  };

  return (
    <>
      {viewPermssion ? (
        <div className="container">
          <div className="reusable_header_main_box">
            <div className="reusable_header_title">Download Report</div>
            <div className="reusable_header_icon_main_box">
              <div
                key="download_excel"
                className="reusable_header_create_box upload-btn"
                onClick={() => {
                  handleExportAction();
                }}
              >
                <img src={DownloadIcon} />
                Download
              </div>
              {icons.map((i, id) => {
                if (i.buttonName) {
                  return (
                    <div
                      key={id}
                      className="reusable_header_create_box"
                      onClick={i.action}
                    >
                      {i.buttonName}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={id}
                      className="reusable_header_icon_box"
                      onClick={i.action}
                    >
                      <img src={i.icon} />
                    </div>
                  );
                }
              })}
            </div>
          </div>


          {showFilter && (
            <Filter
              setShowFilter={setShowFilter}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              FilterAction={FilterAction}
              filterClearAction={filterClearAction}
            />
          )}



          {loading ? (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100vh - 165px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          ) : (
            <>
              <Reusable_table
                header={ConfigData}
                data={report_list}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                maxHeight={
                  "calc(100vh - 220px)"
                }
                maxWidth={"calc(100vw - 240px)"}
              />
            </>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
